<template>
  <v-app>
    <v-container class="pa-6 ma-0 d-flex flex-column gap-6 align-center main-d">
      <!-- section 1 -->
      <v-container class="pa-0 ma-0">
        <CRMfilter
          @apply-filters="HandleApplyFilters"
          @apply-advanced-filters="HandleApplyAdvancedFilters"
        />
        <OverviewCRM
          v-if="crmData && avgInvoiceData"
          :crm-data="crmData"
          :avg-invoice-data="avgInvoiceData"
          :duration="changeDurationText"
        />
      </v-container>
      <!--section 2 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!--increase customer -->
          <v-col cols="12" md="6">
            <AreaIncreaseCustomer
              :filter-chart="filter"
              :advance-filter="advancefilter"
            />
          </v-col>
          <!-- CRM donate-->
          <v-col cols="12" md="6">
            <DonateCRM :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
        </v-row>
      </v-container>
      <!--section 3 -->
      <v-container class="pa-0 ma-0">
        <SalesByCategoryCustomer :filter-chart="filter" :advance-filter="advancefilter" />
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import CRMfilter from "./partial/CRMfilter.vue";
import OverviewCRM from "./partial/OverviewCRM.vue";
import AreaIncreaseCustomer from "./partial/AreaIncreaseCustomer.vue";
import DonateCRM from "./partial/DonateCRM.vue";
import SalesByCategoryCustomer from "./partial/SalesByCategoryCustomer.vue";

export default {
  name: "CRM",
  components: {
    CRMfilter,
    OverviewCRM,
    AreaIncreaseCustomer,
    DonateCRM,
    SalesByCategoryCustomer,
  },
  data: () => ({
    crmData: null,
    avgInvoiceData: null,
    loading: false,
    filter: null,
    advancefilter: null,
    changeDurationText: false,
  }),
  mounted() {
    this.getCRMData();
    this.getAvgData();
  },
  methods: {
    HandleApplyFilters(filters) {
      this.filter = filters;
      this.getCRMData(filters);
      this.getAvgData(filters);
    },
    HandleApplyAdvancedFilters(filters) {
      this.advancefilter = filters;
      this.getCRMData(filters);
      this.getAvgData(filters);
    },
    getCRMData(filters = {}) {
      const hasDefaultDate = !!filters.fromDate && !!filters.toDate;
      const Type = hasDefaultDate ? false : "month";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/invoice-kpi", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data;
          app.crmData = res.crmReport;
          app.changeDurationText = res.flag;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
    getAvgData(filters = {}) {
      const hasDefaultDate = !!filters.fromDate && !!filters.toDate;
      const Type = hasDefaultDate ? false : "month";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/average-invoice-by-users", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data;
          app.avgInvoiceData = res.data;
          app.changeDurationText = res.flag;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.main-d {
  min-width: 400px !important;
}
</style>
